<template>
	<div class="app-header">
		<div class="app-header__header">
			<div
				v-if="$route.meta.origin !== undefined"
				class="app-header__section"
			>
				<AppImage
					class="app-header__logo app-header__logo--small"
					:src="require('@/assets/img/upmood-logo.svg')"
					@click="$router.push({ name: 'dashboard' }).catch(() => {})"
				/>
				<AppIcon
					class="app-header__arrow"
					icon-name="arrowLeft"
					@click="goBack"
                    v-show="$route.name !== 'upmood-mass-view'"
				/>
				<h4
                    v-show="$route.name !== 'upmood-mass-view'"
                    class="app-header__name"
                >
                    {{ $t('back') }}
                </h4>
			</div>

			<div
				v-else
				class="app-header__section"
			>
				<AppImage
					class="app-header__logo"
					:src="require('@/assets/img/upmood-brand.svg')"
					title="Upmood"
					@click="$router.push({ name: 'dashboard' }).catch(() => {})"
				/>
			</div>

			<div
				class="app-header__section"
				@click="showUserMenu = !showUserMenu"
				v-on-clickaway="closeUserMenu"
			>
				<AppImage
					class="app-header__avatar"
					:src="require('@/assets/img/default-avatar.png')"
					:fallback="require('@/assets/img/default-avatar.png')"
					title="avatar"
				/>
				<p class="app-header__username">
					{{ username }}
				</p>

				<p
					v-if="showUserMenu"
					class="app-header__logout"
					@click="signOut"
				>
					{{ $t('logout' )}}
				</p>
			</div>
		</div>

		<ul
			v-if="$route.meta.origin === undefined"
			class="app-header__nav"
			v-on-clickaway="closeSubMenu"
		>
			<li
				class="link"
				:class="{'link--active' : isRouteActive(route)}"
				v-for="route in routes"
				:key="route.label"
				@click="routeClickHandler(route)"
			>
				<!-- <AppIcon
					class="link__icon"
					:icon-name="route.icon"
				/> -->

				{{ $t(route.label) }}

				<template v-if="(route.link instanceof Array)">
					<span class="link__arrow"></span>
					<ul
						class="link__sub"
					>
						<li
							class="link"
							:class="{'link--active' : isRouteActive(subRoute)}"
							v-for="subRoute in route.link"
							:key="subRoute.label"
							@click="routeClickHandler(subRoute)"
						>
							{{ $t(subRoute.label) }}
						</li>
					</ul>
				</template>
			</li>
			<li>
				<AppButton
					class="link__button"
					modifier="large-primary"
					@click="$router.push({ name: 'session-create' })"
				>
					{{ $t('create_session' )}}
				</AppButton>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			activeSubLink: null,
			showUserMenu: false
		}
	},

	computed: {
		...mapState({
			user: state => state.auth.user
		}),

		username () {
			if (!this.user) return ''
			const { first_name, last_name } = this.user
			if (first_name.length + last_name.length > 20) return first_name + ' ...'
			return `${first_name} ${last_name}`
		},

		routes () {
			return [
				{
					label: 'home',
					link: 'dashboard',
					icon: 'dashboard'
				},

				// {
				// 	label: 'analytics',
				// 	link: 'dashboard',
				// 	icon: 'dashboard'
				// },

				{
					label: 'session',
					link: [
						{ label: 'manage_session', link: 'session' },
						{ label: 'archive', link: 'archive' }
					],
					icon: 'session'
				},

				{
					label: 'users',
					link: 'users',
					icon: 'users'
				},

				{
					label: 'upmood_mass',
					link: 'upmood-mass',
					icon: 'router'
				},

				{
					label: 'video_library',
					link: 'library',
					icon: 'router'
				}
			]
		}
	},

	methods: {
		goBack () {
			if (this.$route.meta.origin) this.$router.push({ name: this.$route.meta.origin }).catch(() => {})
			else this.$router.go(-1)
		},

		routeClickHandler (route) {
			if (route.link instanceof Array) return
			if (this.$route.name === route.link) return
			this.$router.push({ name: route.link }).catch(() => {})
		},

		isRouteActive (route) {
			if (route.link instanceof Array) return route.link.some(r => r.link === this.$route.name)
			return route.link === this.$route.name
		},

		signOut () {
			this.$store.dispatch('signOut')
		},

		closeUserMenu () {
			this.showUserMenu = false
		},

		closeSubMenu () {
			this.activeSubLink = null
		}
	}
}
</script>

<style lang="scss" scoped>
.app-header {
	width: 100%;
	padding: 10px;
	z-index: 99;
    font-family: 'Lexend', sans-serif;
    font-weight: 600;

	&__header {
		display: flex;
		align-items: center;
	}

	&__logo {
		width: 80px;
		height: 20px;
		cursor: pointer;

		&--small {
			margin-right: 30px;
			width: 20px;
		}
	}

	&__arrow {
		width: .8em;
		height: 1em;
		margin-right: 1em;
		cursor: pointer;
	}

	&__section {
		display: flex;
		align-items: center;
		position: relative;

		&:first-child {
			flex: 1 1 auto;
		}
	}

	&__avatar {
		border-radius: 50%;
		background-size: cover;
		width: 25px;
		height: 25px;
		cursor: pointer;
	}

	&__username {
		margin-left: 1em;
		font-size: 0.9em;
		cursor: pointer;
	}

	&__nav {
		display: flex;
		align-items: center;
		list-style: none;
		margin-top: 1em;

		.link {
			position: relative;
			cursor: pointer;
			padding: 5px 10px;
			background-color: #434343;
			display: flex;
			align-items: center;
			color: #FFFFFF;

			&__icon {
				width: 1em;
				height: 1em;
				margin-right: 5px;
			}

			&__arrow {
				display: inline-block;
				flex-grow: 0;
				width: .5em;
				height: .5em;
				border: solid currentColor;
				border-width: 0 .1em .1em 0;
				transform: rotate(45deg);
				pointer-events: none;
				margin: 0 8px;
			}

			&__sub {
				display: none;
				position: absolute;
				top: 100%;
				left: 10px;
				white-space: nowrap;
				word-break: keep-all;
				z-index: 9;
				list-style: none;
				background-color: #fff;
				box-shadow: 0 2px 6px #0000000A;
				border: 1px solid #eee;
				border-radius: 5px;
				overflow: hidden;
				color: $default;
			}

			&:hover,
			&--active,
			&--active &__icon,
			&__sub .link:hover,
			&__sub .link--active {
				color: $primary;
			}

			&:hover {
				.link__sub {
					display: block;
				}
			}

			&__button {
				padding: 2px 8px;
				border-radius: 2px;
				margin: 0 1em;
			}
		}
	}

	&__language {
		.icon {
			height: 1em;
			background-color: #eee;
		}

		.option-text {
			text-transform: capitalize;
		}

		/deep/ .app-dropdown {
			&__toggle {
				border: none;
				padding: 0;
			}

			&__options-wrapper {
				width: 10em;
			}
		}
	}

	&__logout {
		position: absolute;
		top: 100%;
		left: -10px;
		margin-top: 10px;
		background-color: #fff;
		padding: 5px 20px;
		font-weight: 600;
		color: $default;
		cursor: pointer;
		border: 1px solid $default-light;
		border-radius: 5px;
		z-index: 999;

		&:after {
			position: absolute;
			content: "";
			left: 15px;
			top: -6px;
			border: 1px solid;
			border-color: $default-light $default-light transparent transparent;
			display: inline-block;
			height: 10px;
			width: 10px;
			background-color: #fff;
			transform: rotateZ(-45deg);
			pointer-events: none;
			z-index: 999;
		}

		&:hover {
			color: $primary;
			border-color: $primary;

			&:after {
				border-color: $primary $primary transparent transparent;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppHeader.vue